import React from "react";

const InterestRate = ({
  title = "Interest Rate / Returns",
  description = "",
  rates = [],
  className = "",
  gradientBg = "bg-gradient-to-r from-orange-400 via-purple-600 to-purple-900",
}) => {
  return (
    <div className={`py-16 sm:py-24 ${gradientBg} ${className}`}>
      <div className="px-6 mx-auto max-w-7xl">
        <div className="grid gap-12 lg:grid-cols-12">
          {/* Left Column - Title Section */}
          <div className="lg:col-span-4">
            <h2 className="text-3xl font-normal text-white sm:text-4xl lg:text-5xl">
              {title}
            </h2>
            {description && (
              <p className="mt-6 text-base text-gray-200 sm:text-lg">
                {description}
              </p>
            )}
          </div>

          {/* Right Column - Products Grid */}
          <div className="grid gap-6 lg:col-span-8 sm:grid-cols-2">
            {rates.map((product, index) => (
              <div key={index} className="p-6 bg-white shadow-lg rounded-xl">
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="text-xl font-medium text-gray-400">
                      {product.product_name}
                    </h3>
                    <p className="mt-1 text-sm text-gray-400">
                      {product.description}
                    </p>
                  </div>
                  <div className="text-3xl font-bold text-orange-500">
                    {`${product.value}%`}
                  </div>
                </div>
                <button
                  className="px-4 py-2 mt-4 text-sm font-medium text-white transition-colors bg-orange-500 rounded-md hover:bg-orange-600"
                  onClick={product.onReadMore}
                >
                  Read More
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterestRate;
